export const COMMUNICATION_ROUTE_SEGMENTS = {
  root: "communication",
  reports: "reports",
  certificationPages: "climatepartner-certification",
  customerInformation: "customer-information",
  createCertificationPage: "create",
  editCertificationPage: "edit",
  transparencyPage: "transparency-page",
} as const;

export const COMMUNICATION_PATH = `/${COMMUNICATION_ROUTE_SEGMENTS.root}`;

export const COMMUNICATION_REPORTS_PATH = `${COMMUNICATION_PATH}/${COMMUNICATION_ROUTE_SEGMENTS.reports}`;

export const COMMUNICATION_CERTIFICATION_PAGES_PATH = `${COMMUNICATION_PATH}/${COMMUNICATION_ROUTE_SEGMENTS.certificationPages}`;

export const COMMUNICATION_CUSTOMER_INFORMATION_PATH = `${COMMUNICATION_CERTIFICATION_PAGES_PATH}/${COMMUNICATION_ROUTE_SEGMENTS.customerInformation}`;

export const COMMUNICATION_CREATE_CERTIFICATION_PAGE_PATH = `${COMMUNICATION_CERTIFICATION_PAGES_PATH}/${COMMUNICATION_ROUTE_SEGMENTS.createCertificationPage}`;

export const buildCommunicationEditCertificationPagePath = (certificationId: string): string =>
  `${COMMUNICATION_CERTIFICATION_PAGES_PATH}/${certificationId}/${COMMUNICATION_ROUTE_SEGMENTS.editCertificationPage}`;

export const COMMUNICATION_TRANSPARENCY_PAGE_PATH = `${COMMUNICATION_PATH}/${COMMUNICATION_ROUTE_SEGMENTS.transparencyPage}`;
